import { useSelector } from 'react-redux';

import type {
  SearchMetadata,
  SearchPageState,
} from '@/productDiscovery/Listings/pages/Search/Search.model';
import {
  selectSearchPageMetadata,
  selectSearchPageState,
} from '@/productDiscovery/Listings/pages/Search/selectors/selectSearchPage';
import { selectSelectedCategoryId } from '@/productDiscovery/Listings/pages/Search/selectors/selectSelectedCategoryId';
import { selectCategoriesList } from '@/productDiscovery/Listings/selectors/categoriesList';

export const useSearch = (): SearchPageState | undefined =>
  useSelector(selectSearchPageState);

export const useSearchCategoryId = (): string | undefined =>
  useSelector(selectSelectedCategoryId);

export const useSearchCategoryName = (): string | undefined => {
  const categoriesList = useSelector(selectCategoriesList);
  const categoryId = useSearchCategoryId();
  return Object.entries(categoriesList).find(
    ([, cat]) => cat.id === `${categoryId}`,
  )?.[0];
};

export const useSearchMetadata = (): SearchMetadata =>
  useSelector(selectSearchPageMetadata);
